import LoadMoreButton from '@rio-cloud/rio-uikit/LoadMoreButton';
import { TableFooter } from '@rio-cloud/rio-uikit/Table';

import type { TableLoadMoreConfig } from './types';

interface DataTableFooterProps {
    loadMore: TableLoadMoreConfig;
}

const DataTableFooter = ({ loadMore }: DataTableFooterProps) => (
    <TableFooter className='bg-white border-top-0 width-100pct padding-top-25'>
        <div className='box-sizing-border-box display-flex height-80 justify-content-center width-100pct padding-0'>
            <LoadMoreButton
                className='margin-y-0'
                loaded={loadMore.loaded}
                total={loadMore.total}
                onLoadMore={loadMore.onLoadMore}
                loadMoreMessage={loadMore.loadMoreMessage ?? 'Load more'}
                noMoreMessage={loadMore.noMoreMessage ?? 'No more items to load'}
                progressBarStyle='gray'
            />
        </div>
    </TableFooter>
);

export default DataTableFooter;
